import React, { Component } from 'react'
import txgloLogo from '../assets/images/txglo.png'
import noaaLogo from '../assets/images/noaa.png'
import tcoastLogo from '../assets/images/tcoast.jpg'
import tamuccLogo from '../assets/images/tamucc.png'

// import appSettings from '../assets/app-settings.json'

export class AboutPage extends Component {

    goToLink = (linkId) => {
        const appSettings = window.AppConfigSettings;
        if (linkId in appSettings.ExternalUrlLinks) {
          const url = appSettings.ExternalUrlLinks[linkId];
          if (url) {
            console.log(url);
    
            window.open(url, '_blank');
          }
        }
      }

    render() {
        return (
            <div>
                <section className="container section-header">
                    <h3> About CHRGIS</h3>
                </section>

                <section id="about" className=" container section-header  section-about">
                    <p>
                        <b>Coastal Habitat Restoration GIS (CHRGIS)</b> provides a data archive and online data visualize tool beaches in the CEPRA Beach Monitoring Program.
                        The monitoring program is sponsored by the Coastal Erosion Planning and Response Act (CEPRA) , which is administered by the TGLO in coordination with NOAA.
                        The purpose of the monitoring program is to document the status of the CEPRA beaches, archive surveys for FEMA reimbursement purposes and provide recommendations addressing potential renourishment and management issues.
                        The restoration of these beaches was originally sponsored by the CEPRA program in conjunction with local entities.
                        The type of restoration is site specific and may include nourishment (importing beach quality sand) or a combination of nourishment along with coastal structures (groins or breakwaters).
                        CEPRA restored beaches are located along both bay and Gulf shores. The CBI monitoring program tracks the performance of 13 of the 33 CEPRA beaches restored along the Texas Coast.
                    </p>

                    <p>
                        CHRGIS provides an interactive web site that allows the user to visualize historic aerial photographs, beach profile survey data, and other site specific information for CEPRA beach nourishment locations along the Texas Coast. The website tool does not require the user to purchase special software and provides visualization in a GIS (Geographic Information System) type of environment through ArcGIS for Servers technology.
                    </p>
                    <p>
                        CHRGIS was originally designed applying University Beach as the prototype. University Beach, a CEPRA restored beach (August, 2001), is located along southern Corpus Christi Bay in front of the Texas A&M University-Corpus Christi campus. University Beach was selected because of the extensive historic data set that was available.
                    </p>
                    <p>
                        <button className="btn btn-outline-danger" onClick={() => this.goToLink('PROJECTHOME')}>Learn more... &raquo;</button>
                    </p>
                </section>

                <section id="sponsors" className="section-header section-sponsors container   ">

                    <div className="page-header header-underline">
                        <h3>
                            Thanks to our Sponsors
                        </h3>
                    </div>

                    <div className="row">
                        <div className="col-xs-6 col-sm-3">
                            <span onClick={() => this.goToLink('TXGLO')}>
                                <img className="image-sponsor" src={txgloLogo} alt="TXGLO" />
                            </span>
                        </div>
                        <div className="col-xs-6 col-sm-3">
                            <span onClick={() => this.goToLink('NOAA')}>
                                <img className="image-sponsor" src={noaaLogo}  alt="NOAA" />
                            </span>
                        </div>
                        <div className="col-xs-6 col-sm-3">
                            <span onClick={() => this.goToLink('TCOAST')}>
                                <img className="image-sponsor" src={tcoastLogo}  alt="TCOAST" />
                            </span>
                        </div>
                        <div className="col-xs-6 col-sm-3">
                            <span onClick={() => this.goToLink('TAMUCC')}>
                                <img className="image-sponsor" src={tamuccLogo}  alt="TAMUCC" />
                            </span>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

export default AboutPage
